import React from 'react';


export default class Advert extends React.Component {

  constructor (props) {
    super(props);
    this.state = {show: true};
  }

  static defaultProps = {
    loop: false,
  }

  componentDidMount () {
    let {video} = this.props.advert;
    if (video) {
      let v = this.refs.video.getDOMNode();
      v.addEventListener('ended', () => this.setState({show: false}));
    }
  }

  render () {
    if (!this.state.show) return null;

    let {image, video} = this.props.advert;
    let {id, loop} = this.props;

    if (image) {
      return (
        <div id={id} className="Advert" onClick={this.props.onClick}>
          <img src={image} alt="" />;
        </div>
      );
    } else if (video) {
      return (
        <div id={id} className="Advert" onClick={this.props.onClick}>
          <video ref='video' src={video} autoPlay loop={loop} />;
        </div>
      );
    } else {
      return null;
    }
  }
}


